import { makeStyles } from '@mui/styles';
import { palette } from '@livable/saas-react-components';
const useStyles = makeStyles({
  alertWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '32px',
    '& .MuiSvgIcon-root': {
      marginRight: '6px'
    }
  },
  unit: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '16px'
  },
  name: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    '& .MuiFormControl-root': {
      marginRight: '10px'
    }
  },
  colorWrapper: {
    display: 'flex',
    flexShrink: '0',
    padding: '0 16px'
  },
  color: {
    width: '48px',
    height: '48px',
    cursor: 'pointer',
    marginLeft: '-1px',
    position: 'relative',
    border: "1px solid ".concat(palette.shades[500]),
    '&.active': {
      '&:after': {
        top: '12px',
        left: '9px',
        width: '28px',
        height: '14px',
        content: "''",
        display: 'block',
        position: 'absolute',
        transform: 'rotateZ(-45deg)',
        borderLeft: "2px solid ".concat(palette.shades[500]),
        borderBottom: "2px solid ".concat(palette.shades[500])
      }
    }
  },
  action: {
    flexShrink: '0'
  }
});
export default useStyles;